import { render, staticRenderFns } from "./-NewBeCreator.vue?vue&type=template&id=58213b62&"
import script from "./-NewBeCreator.js?vue&type=script&lang=js&"
export * from "./-NewBeCreator.js?vue&type=script&lang=js&"
import style0 from "./-NewBeCreator.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports